'use strict'

import PlotController from './controller.js'

export default class Plot {
  /**
   * Represents a base plot, associating flagged <div> with a plot controller
   */

  constructor (type) {
    this.internal = {
      type,
      controllers: []
    }
  }

  wire () {
    // Wire events
    $('[data-plot-type="' + this.internal.type + '"]').each((_, item) => {
      this.internal.controllers.push(new PlotController(item, this.dataFunction))
    })
    return this
  }

  load () {
    for (const controller of this.internal.controllers) {
      controller.init()
    }
    return this
  }

  async dataFunction (controller) {
    // To implement in subclasses
  }
}
